import { request } from '@/utils/request';

export const PayTypes = {
  CreditCard: 'USA101',
  CashApp: 'USA102',
  ApplePay: 'USA103',
  Usdt: 'usa105',
  BTC: 'USA106',
  PayPal: 'USA107'
};

/**
 * @param params 1  首充  2 普通 3 破产 4 阶梯 5 每日礼包  6 限时礼包  9 u充值
 * @returns
 */
export const getRechargeConfig = (params: { p_source: string }) => {
  return request<API.RechargeConfigResponse>({
    url: '/hall/pay_queryconfig_award_pe',
    params
  });
};

export const recharge = (data: API.RechargeRequest) => {
  const types = { [PayTypes.CreditCard]: 1, [PayTypes.Usdt]: 2, [PayTypes.BTC]: 3 };
  data.paytype = types[data.payProduct || PayTypes.CreditCard] || 0;
  return request({
    url: '/payment/bl_sendpayment',
    method: 'post',
    data
  });
};

export const getRechargeRecord = (data: API.RechargeRecordRequest) => {
  return request({
    url: '/yfapi/DBMonitor.gsp_gr_qryuserpayorder_h5',
    method: 'post',
    data
  });
};

/**
 * 救济金
 * @param noconfig
 * @returns
 */
export const getAlms = (noconfig: boolean) => {
  return request({
    url: '/hall/query_jjj_v2',
    method: 'post',
    data: {
      noconfig: noconfig
    }
  });
};

export const takeAlms = () => {
  return request({
    url: '/hall/take_jjj_v2',
    method: 'post'
  });
};

/**
 * 破产
 */
export const getPochan = (): Promise<API.pochanResponse> => {
  return request({
    url: '/api/hall/query_pochan_cz_config_pe',
    method: 'post'
  });
};

/**
 * 阶梯
 */
export const getJietiConfig = () => {
  return request({
    url: '/api/hall/query_step_cz_config_pe',
    method: 'post'
  });
};

export const getJieti = () => {
  return request({
    url: '/yfapi/DBMonitor.gsp_gr_qryuserinfo_wagealms',
    method: 'post'
  });
};

/**
 * 获取配置
 * 1 首充 3 破产
 */
export const getPayconfig = (p_type: 1 | 3): Promise<any> => {
  return request({
    url: '/gamer/get_payconfig',
    method: 'post',
    data: {
      p_type
    }
  });
};

/**
 * 获取用户平均充值金额
 */
export const getAvgpay = () => {
  return request({
    url: '/yfapi/dbmonitor.gsp_gr_qryuserpayinfo_avg',
    method: 'post'
  });
};

/**
 * 获取支付方式
 */
export const getPayType = (data: { p_userid: string }) => {
  return request({
    url: '/yfapi/dbmonitor.gsp_gr_qrypaytype_config',
    method: 'post',
    data
  });
};

/**
 * 每日礼包
 */
export const getDailyPackage = (): Promise<API.DailyPackageResponse> => {
  return request({
    url: '/api/hall/query_day_cz_config_v2_pe',
    method: 'post',
    params: {
      new_cz: 1
    }
  });
};
